import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

import { DateRangePicker, SingleDatePicker } from 'react-dates'
import isBeforeDay from 'react-dates/lib/utils/isBeforeDay'
import Moment from 'moment'

import { PaginationArrowIcon as PaginationForwardIcon } from 'icons/PaginationArrowIcon/PaginationArrowIcon'

import { TEXT_STYLES } from 'TEXT_STYLES'

const CalendarWrapper = styled.div`
  .CalendarDay__default {
    width: 36px !important;
    height: 35px !important;
  }
  .DateRangePicker {
    width: 100%;
    .DateRangePicker_picker {
      top: 34px !important;
      ${props =>
        props.focusedInput === 'endDate' &&
        `
        right: 0 !important;
        left: auto !important;
      `}
    }
    .DateRangePickerInput {
      width: 100%;
      display: flex;
    }
    .DateInput_fang {
      display: none;
    }
    .DayPickerNavigation_button {
      border: none;
    }
  }
  .SingleDatePicker_picker {
    position: absolute;
    top: auto !important;
    left: auto !important;
    right: 0px;
  }
  .DateInput {
    &::after {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 25px;
      height: 25px;
      content: url(${require('../../icons/svg/calendar.svg')});
    }
  }

  .DateInput_input {
    flex: 1;
    height: 35px;
    min-height: 35px;
    outline-style: none;
    padding-left: 10px;
    ${TEXT_STYLES.BodyBlack}
    text-align: left;
    border-radius: 2px;
    border: solid 1.3px ${props => props.theme.colors.coolGrey300};
    &::placeholder {
      color: ${props => props.theme.colors.grey500};
    }

    ${props =>
      props.error && `border: 1px solid  ${props.theme.colors.red500};`}
  }
  .DayPicker {
    width: 300px !important;
    border: 1px solid ${props => props.theme.colors.coolGrey300};
    border-radius: 1px;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.1);
  }
  .DayPicker_transitionContainer {
    width: 295px !important;
  }
  .DayPicker_weekHeader_li {
    width: 36px !important;
  }
  .DayPicker_weekHeader_ul {
    margin-top: -7px;
    ${TEXT_STYLES.H4Inactive}
  }
  .DayPickerNavigation__horizontal {
    display: flex;
    justify-content: space-between;
    margin: 0 45px 0 25px;
    top: 20px;
  }
  .DayPickerNavigation_rightButton__horizontal {
    right: 42px;
  }
  .CalendarMonth {
    padding: 0 !important;
  }
  .CalendarMonthGrid__horizontal {
    left: 22px;
  }
  .CalendarMonthGrid_month__horizontal:nth-child(odd) {
    margin-left: 22px;
  }
  .CalendarMonth_table td {
    border: 1px solid ${props => props.theme.colors.coolGrey300};
  }
  .CalendarDay {
    ${TEXT_STYLES.H4Black}
  }
  .CalendarDay__blocked_calendar {
    position: relative;
    background: ${props => props.theme.colors.coolGrey300};
    &.CalendarDay__selected_span {
      color: ${props => props.theme.colors.grey900};
    }
    &.CalendarDay__selected {
      color: ${props => props.theme.colors.white};
    }

    &:hover {
      color: ${props => props.theme.colors.grey900} !important;
      background-color: ${props => props.theme.colors.coolGrey300} !important;

      ${props =>
        props.blockedTooltip &&
        `
          &:before {
            content: '';
            position: absolute;
            top: 37px;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid ${props.theme.colors.coolGrey700};
          }

          &:after {
            font-size: 12px;
            font-weight: normal;
            color: ${props.theme.colors.white};
            content: '${props.blockedTooltip}';
            position: absolute;
            top: 42px;
            left: -5px;
            width: 120px;
            height: 45px;
            padding: 5px;
            background:  ${props.theme.colors.coolGrey700};
            z-index: 1;
            border-radius: 1px;
            text-align: left;
          }
      `}
    }
  }

  .CalendarDay__selected_span,
  .CalendarDay__hovered_span {
    background-color: ${props => props.theme.colors.coolGrey050};
  }

  .CalendarDay__hovered_span {
    color: ${props => props.theme.colors.grey900};

    &:hover {
      color: ${props => props.theme.colors.grey900};
    }
  }

  .CalendarDay__today,
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.orange500};
    border-color: ${props => props.theme.colors.coolGrey300};
  }

  .CalendarDay__default:hover {
    background-color: ${props => props.theme.colors.coolGrey050};
    border-color: ${props => props.theme.colors.coolGrey300};
    &.CalendarDay__selected_span {
      background-color: ${props => props.theme.colors.coolGrey050};
      border-color: ${props => props.theme.colors.coolGrey300};
      color: ${props => props.theme.colors.grey900};
    }
    &.CalendarDay__selected {
      color: ${props => props.theme.colors.white};
      background-color: ${props => props.theme.colors.primary};
    }
  }

  .CalendarMonth_caption {
    ${TEXT_STYLES.H3Black}

    strong {
      font-weight: 600 !important;
    }
  }
`

const PaginationBackwardIcon = styled(PaginationForwardIcon)`
  transform: rotate(180deg);
`

class CalendarInput extends Component {
  shouldComponentUpdate(nextProps) {
    // To improve react-dates loading time and to prevent
    // lag when using other components in the same container
    // as the Calendar, we ensure that the Calendar only
    // rerenders when the dates or the focusedInput is updated
    if (this.props.startDate !== nextProps.startDate) {
      return true
    }
    if (this.props.endDate !== nextProps.endDate) {
      return true
    }
    if (this.props.focusedInput !== nextProps.focusedInput) {
      return true
    }
    if (this.props.error !== nextProps.error) {
      return true
    }
    return false
  }

  render() {
    const {
      onDatesChange,
      onFocusChange,
      focusedInput,
      startDate,
      startDatePlaceholder,
      endDate,
      blockPastDates,
      isDayBlocked,
      onPrevMonthClick,
      onNextMonthClick,
      className,
      error,
      mode,
      id,
      blockedTooltip,
      keepOpenOnDateSelect,
      isDayHighlighted,
      displayFormat
    } = this.props

    return (
      <CalendarWrapper
        className={className}
        focusedInput={focusedInput}
        error={error}
        mode={mode}
        blockedTooltip={blockedTooltip}>
        {mode === 'single' ? (
          <SingleDatePicker
            id={id}
            date={startDate}
            onDateChange={onDatesChange}
            onFocusChange={onFocusChange}
            focused={focusedInput}
            placeholder={startDatePlaceholder}
            verticalSpacing={0}
            numberOfMonths={1}
            isOutsideRange={() => false}
            noBorder
            hideKeyboardShortcutsPanel
            keepOpenOnDateSelect={keepOpenOnDateSelect}
            navNext={<PaginationForwardIcon />}
            navPrev={<PaginationBackwardIcon />}
            isDayBlocked={isDayBlocked}
            isDayHighlighted={isDayHighlighted}
            displayFormat={displayFormat}
          />
        ) : (
          <DateRangePicker
            onDatesChange={onDatesChange}
            onFocusChange={onFocusChange}
            focusedInput={focusedInput}
            startDate={startDate}
            startDateId="startDate"
            endDate={endDate}
            endDateId="endDate"
            numberOfMonths={1}
            navNext={<PaginationForwardIcon />}
            navPrev={<PaginationBackwardIcon />}
            customArrowIcon={<span />}
            isDayBlocked={day => blockPastDates && isBeforeDay(day, Moment())}
            onPrevMonthClick={onPrevMonthClick}
            onNextMonthClick={onNextMonthClick}
            noBorder
            hideKeyboardShortcutsPanel
          />
        )}
      </CalendarWrapper>
    )
  }
}

CalendarInput.propTypes = {
  onDatesChange: PropTypes.func.isRequired,
  onFocusChange: PropTypes.func.isRequired,
  focusedInput: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  startDate: PropTypes.object,
  startDatePlaceholder: PropTypes.string,
  endDate: PropTypes.object,
  endDatePlaceholder: PropTypes.string,
  blockPastDates: PropTypes.bool,
  onPrevMonthClick: PropTypes.func,
  onNextMonthClick: PropTypes.func,
  error: PropTypes.bool,
  mode: PropTypes.string,
  id: PropTypes.string,
  isDayBlocked: PropTypes.func,
  isDayHighlighted: PropTypes.func,
  blockedTooltip: PropTypes.string,
  keepOpenOnDateSelect: PropTypes.bool,
  displayFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
}
export { CalendarInput }
